module.exports = __webpack_public_path__ + "bd4e6e767620384986900ea4eb9b7a0d.glb";